<template>
  <div id="app">
    <app-header />
    <main>
      <step-one v-if="step === 'one'" @clicked="updateNav" />
      <step-two v-if="step === 'two'" @clicked="updateNav" />
      <step-three v-if="step === 'three'" @clicked="updateNav" />
      <step-four v-if="step === 'four'" @clicked="updateNav" :size="size" />
      <step-five
        v-if="step === 'five'"
        @clicked="updateNav"
        :id="id"
        :url="url"
        :size="size"
        :image="image"
        :textLink="textLink"
      />
    </main>
    <app-footer />
  </div>
</template>

<script>
import AppHeader from "@/components/AppHeader.vue";
import AppFooter from "@/components/AppFooter.vue";
import StepOne from "@/components/StepOne.vue";
import StepTwo from "@/components/StepTwo.vue";
import StepThree from "@/components/StepThree.vue";
import StepFour from "@/components/StepFour.vue";
import StepFive from "@/components/StepFive.vue";

export default {
  name: "app",

  components: {
    AppHeader,
    AppFooter,
    StepOne,
    StepTwo,
    StepThree,
    StepFour,
    StepFive
  },

  data() {
    return {
      step: "one",
      id: "",
      url: "",
      size: "",
      image: "",
      textLink: false
    };
  },

  mounted() {
    this.$bus.$on("id", id => {
      this.id = id;
    });
    this.$bus.$on("url", url => {
      this.url = url;
    });
    this.$bus.$on("size", size => {
      this.size = size;
    });
    this.$bus.$on("image", image => {
      this.image = image;
    });
    this.$bus.$on("textLink", textLink => {
      this.textLink = textLink;
    });
  },

  beforeDestroy() {
    this.$bus.$off("id");
    this.$bus.$off("url");
    this.$bus.$off("size");
    this.$bus.$off("image");
    this.$bus.$off("textLink");
  },

  methods: {
    updateNav(val) {
      this.step = val;
    }
  }
};
</script>

<style>
html {
  background-color: var(--lt-gray);
}

#app {
  max-width: 1152px;
  margin: 0 auto;
  background-color: var(--white);
}

.narrow {
  display: block;
}

.wide {
  display: none;
}

@media (min-width: 768px) {
  .narrow {
    display: none;
  }

  .wide {
    display: block;
  }
}
</style>
